// material-ui
import './UIComponent.css'
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const Logo = () => {
  return <div className='kutest-admin-logo'>
    <img className="kutest-admin-logo-image" src="/logo.png" />
    <div className="kutest-admin-logo-description">통번역자격시험</div>
  </div>
};

export default Logo;
